import QuickLinks from './components/quick_links';
import { initializeComponents } from "~/utils/bundle_utils";

initializeComponents('#vue-quick-links-trigger', QuickLinks);